import { InjectionToken } from '@angular/core';
import { environment } from 'src/environments/environment';

export const ENC_DOMAIN_NAME = new InjectionToken<string>('DOMAIN_NAME', {
    providedIn: 'root',
    factory: () => btoa(environment.domainName) as string,
});
